import React from 'react';
import { Link } from 'react-router-dom';
import { WrenchIcon, BookOpenIcon } from 'lucide-react';
const SoftServiceSection = () => {
  return <section className="py-16 bg-mwc-lightpink" data-id="element-66">
      <div className="container mx-auto px-4" data-id="element-67">
        <div className="flex flex-col md:flex-row items-center" data-id="element-68">
          <div className="md:w-1/3 mb-8 md:mb-0 flex justify-center" data-id="element-69">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rx3NcGjdFyxpRgP7V2e5u5/Maplewood_staff_fixing_Dishwasher.jpg" alt="Maplewood Care Engineer Fixing Dishwasher" className="max-w-full md:max-w-xs object-cover rounded-md shadow-md" data-id="element-70" />
          </div>
          <div className="md:w-2/3 md:pl-8" data-id="element-71">
            <div className="text-center md:text-left" data-id="element-72">
              <div className="inline-block p-3 bg-white rounded-full text-mwc-burgundy mb-6" data-id="element-73">
                <BookOpenIcon size={32} data-id="element-74" />
              </div>
              <h2 className="text-3xl font-bold text-mwc-burgundy mb-4" data-id="element-75">
                Self-Help Guides and Troubleshooting Advice
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-76">
                We understand how frustrating appliance problems can be, but
                sometimes simple diagnostics can identify the issue quickly.
                Many common faults can be resolved at home without requiring an
                engineer callout.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-77">
                Before booking a repair visit, explore our easy-to-follow
                troubleshooting guides. They help you diagnose and resolve minor
                problems safely and efficiently, potentially saving you time and
                service costs.
              </p>
              <Link to="/soft-services" className="inline-flex items-center bg-mwc-green hover:bg-mwc-green/80 text-white font-semibold px-6 py-3 rounded-md transition-colors duration-300" data-id="element-78">
                <WrenchIcon size={18} className="mr-2" data-id="element-79" />
                View Troubleshooting Guides
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default SoftServiceSection;